import * as React from "react";
import { connect } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { DropdownMultiSelect } from "../../Common/Components/DropdownMultiSelect";
import { TransactionService } from "../../Common/Services/TransactionService";
import {
  Container,
  Dropdown,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { LocationService } from "../../Common/Services/LocationService";
import { Utils } from "../../Common/Utilis";
import { BankService } from "../../Common/Services/BankService";
import { resolve, reject } from "q";
import "../../App.scss";

import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { FiChevronDown } from "react-icons/fi";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ScrollContainer from "react-indiana-drag-scroll";
import { CommentBox } from "../../Common/Components/CommentBox";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
let routeLeavingGuard: any = null;
let requestInProcess = false;
 class BankMasterSlidout extends React.Component<any, any> {

  private parentScroll: any;
  private accountNoRef: any;


  constructor(props: any) {
    super(props);
    this.parentScroll = React.createRef();
    this.accountNoRef = React.createRef();
    this.state = {
      coaList: [],
      lock:false,
      bankList:[],
      editAccountNo: false,
      showField: false,
      BankName:"Select",
      accountTypeList: [{ id: 'Checking', name: 'Checking' }, { id: 'Savings', name: 'Savings' }],
         selectOptions: [
        {
          id: 'Active', name: 'Active'
        },
        { id: 'Inactive', name: 'Inactive' }

      ],
      formData: {
        id: this.props.bankId,
        AccountNo: '',
        lastAccountNo: '',
        city: "",
        state: "",
        zip: "",
        phone: "",
        email: "",
        sharingid:0,
        ispayrollDefault:false,
        isprimary:false,
        coa:""
      },

    };

  }


  beforeunload(e: { preventDefault: () => void; returnValue: boolean }) {
    if (
      this.state.isStateChanged &&
      routeLeavingGuard !== "routeLeavingGuardTrue"
    ) {
      e.preventDefault();
      e.returnValue = true;
    }
  }

  routeLeavingGuardConfirm = (childState: any) => {
    if (childState === true) {
      routeLeavingGuard = "routeLeavingGuardTrue";
    } else {
      routeLeavingGuard = null;
    }
  };

  componentDidMount() {
       this.getBankMaster();

    if (this.props.bankId == 0){
      this.setState({ showField: true, editAccountNo: true });
          this.existingBankMaster();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Focus the input field when editAccountNo is set to true
    if (this.state.editAccountNo && this.state.editAccountNo !== prevState.editAccountNo) {
      this.accountNoRef.current.focus();
    }
    if (prevProps.locationId != this.props.locationId) {
      this.closeSlideOut();
    }
  }

  existingBankMaster  = async () => {
  const { requestlist } = this.state;

  try {
    const locations = await LocationService.GetLocationAll({ ...requestlist });

    if (!Array.isArray(locations) || locations.length === 0) return;
    const locWithType1 = locations.find(loc => loc.locType === 1);
    if (!locWithType1) return;

    const updatedRequest = {
      ...requestlist,
      locationId: locWithType1.locationId,
      isBank:true
    };

    const banks = await BankService.GetBanks1(updatedRequest);

    if (banks) {
       const bank = banks.map(bank => ({
        ...bank,
        name: bank.bankName,
      }));

      this.setState({ bankList: bank });
    }
  } catch (err) {
    toast.error(`Server Error: ${err}`);
  }
};

  handleSelectedItem1 = (control: any, id: any) => {
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        status: id
      }
    }));
  };
  handleSelectedItem = (control: any, id: any) => {
    if (this != undefined) {
      if (control === 'AccountType') {
        let formData = this.state.formData;
        formData.AccountType = id;
        this.setState({ formData, isStateChanged: true });
      }if (control === 'Loadprev') {
        const selectedBank = this.state.bankList.find(bank => bank.id === parseInt(id));
    if (selectedBank) {
      const formData = {
        sharingid: selectedBank.id, 
        id: 0,
        BankName: selectedBank.bankName,
        AccountNo: selectedBank.accountNo,
        Balance: selectedBank.balance,
        locationId: selectedBank.locationId,
        Phone: selectedBank.phone,
        Email: selectedBank.email,
        RoutingNumber: selectedBank.routingNumber,
        AccountType: selectedBank.accountType,
        accountname: selectedBank.accountname,
        displayname: selectedBank.displayname,
        bankcode: selectedBank.bankcode,
        bankStreet1: selectedBank.bankStreet1,
        bankStreet2: selectedBank.bankStreet2,
        status: selectedBank.status,
        abarounting: selectedBank.abarounting,
        startingcheck: selectedBank.startingcheck,
        checkseries: selectedBank.checkseries,
        street: selectedBank.street,
        city: selectedBank.city,
        state: selectedBank.state,
        zip: selectedBank.zip,
        lastAccountNo: selectedBank.lastAccountNo,
        nickname: selectedBank.nickName,
        coa: selectedBank.coa,
      };

      this.setState({ formData, isStateChanged: true,BankName: selectedBank.bankName,lock:true,accountTypeList:[]},()=>{
        // this.setState({      
        //   accountTypeList: [{ id: 'Checking', name: 'Checking' }, { id: 'Savings', name: 'Savings' }],});
      });
      }
    }
      

    }
  };

  getBankMaster = () => {

    let requestlist = { ...this.state.requestlist };
    requestlist.bankId = this.props.bankId;
    BankService.GetBankMasterById(requestlist)
      .then(async (result: any | null) => {

        if (result != null) {
          let formData = { ...this.state.formData };

          formData.id = result.id;
          formData.BankName = result.bankName;
          formData.TenantId = result.tenantId;
          formData.AccountNo = result.accountNo;
          formData.lastAccountNo = result.lastAccountNo;
          formData.AccountType = result.accountType;
          formData.RoutingNumber = result.routingNumber;

          formData.Email = result.email;
          formData.Phone = result.phone;
          formData.street = result.street;
formData.status=result.status;
          formData.zip = result.zip;
          formData.nickname=result.nickName;
          formData.startingcheck=result.startingcheck;
          formData.checkseries=result.checkseries;
          formData.Balance=Utils.currencyFormat(result.balance);
          formData.city = result.city;
          formData.state = result.state;
          formData.sharingid=result.sharingid;
          formData.ispayrollDefault= result.ispayrollDefault;
          formData.isprimary= result.isprimary;
          formData.coa= result.coa;
          let editAccountNo = (formData.AccountNo == null || formData.AccountNo == '' || formData.AccountNo.length < 5);
        
         
          this.setState({ formData: formData, showField: true, editAccountNo: editAccountNo ,lock: result.sharingid==0 ? false : true,coaList:[]});
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };


  //Save all entered data into db and handle the created vendor as selected in dropdown
  saveItem = async () => {
   const {formData} = this.state;
    if (requestInProcess == true) {
      toast.error("Subsequent request has been made.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

     if (!formData.BankName || formData.BankName.trim() === "") {
    toast.error("Bank Name is required.", { position: toast.POSITION.BOTTOM_RIGHT });
    return;
  }

  const isNew = formData.id === 0 && formData.sharingid === 0;
  const accountNoToValidate = isNew ? formData.AccountNo : formData.lastAccountNo;

  if (!accountNoToValidate || accountNoToValidate.trim() === "") {
    toast.error("Account No. is required.", { position: toast.POSITION.BOTTOM_RIGHT });
    return;
    
  }

  if (!formData.nickname || formData.nickname.trim() === "") {
    toast.error("Short Name is required.", { position: toast.POSITION.BOTTOM_RIGHT });
    return;
  }

  console.log("pp",String(formData.startingcheck).trim());
    if (!formData.startingcheck || String(formData.startingcheck).trim() === "") {
    toast.error("Starting check is required.", { position: toast.POSITION.BOTTOM_RIGHT });
    return;
  }
 
 if (!formData.checkseries || formData.checkseries.trim() === "") {
    toast.error("Check series is required.", { position: toast.POSITION.BOTTOM_RIGHT });
    return;
  }

  if (!formData.coa || formData.coa.trim() === "") {
    toast.error("COA is required.", { position: toast.POSITION.BOTTOM_RIGHT });
    return;
  }

  if (formData.coa.length != 4) {
    toast.error("COA length doesn't match.", { position: toast.POSITION.BOTTOM_RIGHT });
    return;
  }
  
 
   

    this.setState({ isSaveSpinner: true });
    requestInProcess = true;
    debugger;

    this.state.formData.Balance= parseFloat(Utils.removecurrencyFormat(this.state.formData.Balance?this.state.formData.Balance:0));
    this.state.formData.isBank = true;
    BankService.SaveBankMaster(this.state.formData)
      .then(async (result: any | null) => {


        if (result !== null) {

            if(result.accountNo == "duplicate"){
            toast.error("Account no. / Routing no already exists.",
                {
                  position: toast.POSITION.BOTTOM_RIGHT,
                }
              );
            }
             else if(result.coa == "duplicate"){
            toast.error("COA  already exists.",
                {
                  position: toast.POSITION.BOTTOM_RIGHT,
                }
              );
            }
            else if (formData.id > 0 ) {
              let requestlist: any = {};
              toast.success("Bank updated successfully.",
                {
                  position: toast.POSITION.BOTTOM_RIGHT,
                }
              );
              this.getBankMaster();
            }  else if (formData.id == null || formData.id == 0 || formData.id == "") {
              let requestlist: any = {};
              toast.success("Bank created successfully.",
                {
                  position: toast.POSITION.BOTTOM_RIGHT,
                }
              );
            } else {
              toast.error(result.message, {
                position: toast.POSITION.BOTTOM_RIGHT,
              });
            }
          }
          
          this.setState({ isSaveSpinner: false, editAccountNo: false });
          requestInProcess = false;
          if(result.accountNo !== "duplicate" && result.coa !== "duplicate"  && (!formData.id || formData.id == 0 || formData.id == "")) this.closeSlideOut();
          resolve();
        })
        .catch((error) => {
          this.setState({ isSaveSpinner: false });
          requestInProcess = false;
          reject();
        }
        );
  };

   onAmountFocus = (e, index, txtID, type: any) => {
      const { formData } = this.state;
    
  
      let start = e.target?.selectionStart;
      let end = e.target?.selectionEnd;
      if (type === "Balance") {
        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;
        formData.Balance = e.target.value;
  
        
      }
    };
  


  amountBlur = (e, rowIndex, type: any, row: any) => {
      const { formData } = this.state;
     if (type === "Balance") {
          let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
          e.target.value = newVal;
          formData.Balance =
            e.target.value === ""
              ? ""
              : !isNaN(e.target.value)
              ? Utils.currencyFormat(e.target.value)
              : e.target.value;
        // }
      }
      this.setState({ formData }, () => {});
    };
  

  closeSlideOut = () => {
    this.props.closeSlideOut(this.state?.shouldReloadMainPage);
  };

  handleChange = (event: any, FieldType: string) => {

    let isStateChanged = true;

    let formData = { ...this.state.formData };

    if (FieldType === "BankName") {
      formData.BankName = event.target.value;
    }
    else if (FieldType === "AccountNo") {
      formData.AccountNo = event.target.value;
      formData.lastAccountNo = event.target.value;
    }
    else if (FieldType === "RoutingNumber") {
      formData.RoutingNumber = event.target.value;
    }
    else if (FieldType === "street") {
      formData.street = event.target.value;
    }
    else if (FieldType === "email") {
      formData.Email = event.target.value;
    }

    else if (FieldType === "nickname") {

    formData.nickname=event.target.value;
    }
    else if (FieldType === "startingcheck") {
         let val = event.target.value.replace(/[^0-9()-\s]/g, '');

      formData.startingcheck = val;
    }
    else if (FieldType === "checkseries") {
    formData.checkseries=event.target.value;
    }
    else if (FieldType === "Balance") {
    formData.Balance=event.target.value;
    }
    else if (FieldType === "phone_number") {

      let val = event.target.value.replace(/[^0-9()-\s]/g, '');

      formData.Phone = val;
    }
    else if (FieldType === "city") {
      formData.city = event.target.value;
    }
    else if (FieldType === "state") {
      formData.state = event.target.value;
    }
    else if (FieldType === "zip") {
      formData.zip = event.target.value;
    }else if(FieldType === "isDefault"){
      formData.ispayrollDefault = event.target.checked;
    }
    else if(FieldType === "isprimary"){
      formData.isprimary = event.target.checked;
    } else if (FieldType === "coa") {
  let val = event.target.value.replace(/[^0-9()-\s]/g, '');

      formData.coa = val;

    }


    this.setState({ formData, isStateChanged, isSpinner: false }, () => {

    });
  };

    updateMultiSelectItem = (selectedItems: any[]) => {
    const { formData } = this.state;
  
    const selectedValues = selectedItems.map((item) => parseInt(item.value, 10));
  
    this.setState({
      formData: {
        ...formData,
        selectedIds: selectedValues,
      },
      isStateChanged:true
    });
  };
  

  render() {
    const { permissions } = this.props; 
    const hasAddPermission = permissions && permissions['Bank Master'] ? permissions['Bank Master'].includes('Add Bank') : false;
    const hasEditPermission = permissions && permissions['Bank Master'] ? permissions['Bank Master'].includes('Edit Bank') : false;

    const {
    lock

    } = this.state;


    return (
      //  <div className="transaction-slideout invoice-entry pos-fxd index-1000">

      <section>
        <div className="details-drawer"
          style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
        // className="back-drop1  viewer-panel1 opacity "
        >
          <ToastContainer
            containerId={"userDetailSlideoutcontainer"}
            autoClose={3000}
          />

          <div className="d-flex">
            {!this.state.isOpenViewer && (
              <div
                className="back-drop1  viewer-panel1 opacity "
                // onClick={() => this.closeSlideOut()}
              ></div>
            )}

            <Container
              fluid

              className="body-sec viewer-panel back-drop p-0 "
              style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}

            >
              <div
                className="container-fluid py-1 bg-white d-flex align-items-center  border-bottom round-4"
              >
                <div className="divheader">
                  <h5 className="my-title">
                    {this.state.formData.id == 0 ? <span>New Bank </span> : <span> Bank Details </span>}

                  </h5>
                   {this.state.formData.sharingid != 0  && 
                                        <span className="badge badge-pill badge-primary color-green">
                                        Shared Bank
                                        </span>
                                         }


                  <div className="header-popout ml-auto">





                    <div className="container text-center">
                      <div className="row align-items-start">
                        <div className="col">
                        </div>

                        <div className="col">
                          <button
                            type="button"
                            className="btn btn-primary cross"
                            onClick={this.closeSlideOut}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                                fill="#ffffff"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              
              <div
                className="scroll"
              >

                <section className="pb-3">
                 {(this.state.bankList.length > 0 && this.state.formData.id == 0) && 
                <div className="col-md-6 mb-3" >
                          <Form.Group className="rm-bottom-margin" controlId="AccountType">
                            <Form.Label>Select from existing</Form.Label>
                            <div className="w-auto" >
                                <SingleDropdownListWithoutSearch
                                  tabIndex={this.state.tabEnable}
                                  itemList={this.state.bankList}
                                  handleSelectedItem={this.handleSelectedItem.bind(this, "Loadprev")}
                                  defaultItem={this.state.formData.BankName}
                                  //defaultText={"Select Employee"}
                                  defaultName={this.state.BankName}
                                  controlID="1"
                                  id={"ddlAccountType"}
                                  disabled={false}
                                />
                            </div>

                          </Form.Group>
                        </div>
                  }
                  
                <div className="row g-3">

                  <div className="col-12 col-md-6" >                   
                      <div className="card h-100">
                          <div className="card-header d-flex justify-content-between align-items-center">
                          <span className="mb-0">Bank Details</span>
                          <div className="d-flex align-items-center">
                            <Form.Label className="mb-0 font-semibold">Set as Primary</Form.Label>
                            <div className="form-check form-switch m-0">
                              <Form.Check
                                className="knob"
                                id="payrollbank"
                                type="switch"
                                checked={this.state.formData.isprimary}
                                onChange={(event) => this.handleChange(event, "isprimary")}
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>                    
                        <div className="card-body">
                        <div className="row g-3">
                        <div className="col-md-6" >
                          <Form.Group className="rm-bottom-margin" controlId="bankName">
                            <Form.Label> Bank Name</Form.Label>
                            <div className="single-select">
                              <Form.Control type="text" id="txtbankName"
                                value={this.state.formData.BankName}
                                autoComplete='off'
                                disabled={lock}
                                onChange={(event: any) =>
                                  this.handleChange(event, "BankName")}
                              />
                            </div>

                          </Form.Group>
                         </div>

                         <div className="col-md-6" >
                          <Form.Group className="rm-bottom-margin" controlId="nickname">
                            <Form.Label> Short Name</Form.Label>
                            <div className="single-select">
                              <Form.Control type="text" id="txtbankName"
                                value={this.state.formData.nickname}
                                autoComplete='off'
                                disabled={lock}
                                onChange={(event: any) =>
                                  this.handleChange(event, "nickname")}
                              />
                            </div>

                          </Form.Group>
                         </div>
                          <div className="col-md-6" >
                          <Form.Group className="rm-bottom-margin" controlId="AccountType">
                            <Form.Label> Account Type</Form.Label>
                            <div className="w-auto" >
                                {(this.state.formData.AccountType != null || this.state.showField) && <SingleDropdownListWithoutSearch
                                  tabIndex={this.state.tabEnable}
                                  itemList={this.state.accountTypeList}
                                  handleSelectedItem={this.handleSelectedItem.bind(this, "AccountType")}
                                  defaultItem={this.state.formData.AccountType}
                                  //defaultText={"Select Employee"}
                                  defaultName={this.state.formData.AccountType}
                                  controlID="1"
                                  id={"ddlAccountType"}
                                  disabled={lock}
                                />}
                            </div>

                          </Form.Group>
                        </div>
                        <div className="col-md-6" >
                        <Form.Group className="rm-bottom-margin" controlId="AccountNo">
                          <Form.Label> Account No </Form.Label>
                          <div className="single-select">
                            {/* {!this.state.editAccountNo &&  <Form.Label onClick={()=>{ this.setState({editAccountNo:true});}}>{String(this.state.formData.AccountNo).slice(0, -4).replace(/./g, '*') + String(this.state.formData.AccountNo).slice(-4)}</Form.Label>} */}
                            <Form.Control type="text" id="txtAccountNo"
                              value={this.state.formData.id == 0 && this.state.formData.sharingid == 0 ? this.state.formData.AccountNo : this.state.formData.lastAccountNo}
                              autoComplete='off'
                              disabled={lock}
                              onChange={(event: any) =>
                                this.handleChange(event, "AccountNo")}
                              ref={this.accountNoRef}
                            />
                          </div>
                        </Form.Group>
</div>


<div className="col-md-6" >


                        <Form.Group className="rm-bottom-margin" controlId="RoutingNumber">
                          <Form.Label> Routing Number</Form.Label>
                          <div className="date-picker calender-picker">
                            <Form.Control type="text" id="txtRoutingNumber"
                              value={this.state.formData.RoutingNumber}
                              autoComplete='off'
                              disabled={lock}
                              onChange={(event: any) =>
                                this.handleChange(event, "RoutingNumber")}
                            />
                          </div>
                        </Form.Group>
</div>
<div className="col-md-6" >


                        <Form.Group className="rm-bottom-margin" controlId="Balance">
                          <Form.Label> Opening Balance</Form.Label>
                          <div className="date-picker calender-picker">
                            <Form.Control type="text" id="txtRoutingNumber"
                              value={this.state.formData.Balance}
                              autoComplete='off'
                              disabled={lock}
                              onChange={(event: any) =>
                                this.handleChange(event, "Balance")}

                                onBlur={(e: any) =>
                                  this.amountBlur(
                                    e,
                                    null,
                                    "Balance",
                                    null
                                  )
                                }
                                onFocus={(e: any) =>
                                  this.onAmountFocus(
                                    e,
                                    null,
                                    "Balance",
                                    "Balance"
                                  )
                                }
                            />
                          </div>
                        </Form.Group>
</div>
<div className="col-md-6" >


                        <Form.Group className="rm-bottom-margin" controlId="startingcheck">
                          <Form.Label> Starting Check No</Form.Label>
                          <div className="date-picker calender-picker">
                            <Form.Control type="text" id="txtRoutingNumber"
                              value={this.state.formData.startingcheck}
                              autoComplete='off'
                              disabled={lock}
                              onChange={(event: any) =>
                                this.handleChange(event, "startingcheck")}
                            />
                          </div>
                        </Form.Group>
</div>

<div className="col-md-6" >


                        <Form.Group className="rm-bottom-margin" controlId="checkseries">
                          <Form.Label> Check Series</Form.Label>
                          <div className="date-picker calender-picker">
                            <Form.Control type="text" id="txtRoutingNumber"
                              value={this.state.formData.checkseries}
                              autoComplete='off'
                              disabled={lock}
                              onChange={(event: any) =>
                                this.handleChange(event, "checkseries")}
                            />
                          </div>
                        </Form.Group>
</div>

<div className="col-md-6" >
   <Form.Group className="rm-bottom-margin" controlId="coa">
                          <Form.Label>  Chart of Accounts</Form.Label>
                          <div className="date-picker calender-picker">
                            <Form.Control type="text" id="txtRoutingNumber"
                              value={this.state.formData.coa}
                              autoComplete='off'
                              disabled={lock}
                              onChange={(event: any) =>
                                this.handleChange(event, "coa")}
                            />
                          </div>
                        </Form.Group>

</div>

</div>
</div>
                     
                    </div>
                  </div>
               
                  {/* Right Column */}
                  <div className="col-12 col-md-6"   >
                    <div className="card h-100">
                      <div className="card-header">Contact Details</div>
                      <div className="card-body">
                      <div className="row g-3">
                      <div className="col-md-12" >
                        <Form.Group className="rm-bottom-margin" controlId="street">
                          <Form.Label> Street</Form.Label>
                          <div className="single-select">
                            <Form.Control type="text" id="txtstreet"
                              value={this.state.formData.street}
                              autoComplete='off'
                              className="form-controlCustom"
                              disabled={lock}
                              onChange={(event: any) =>
                                this.handleChange(event, "street")}
                            />
                          </div>

                        </Form.Group>
</div>
<div className="col-md-6" >
                        <Form.Group className="rm-bottom-margin" controlId="email">
                          <Form.Label> Email</Form.Label>
                          <div className="date-picker calender-picker">
                            <Form.Control type="text" id="txtemail"
                              value={this.state.formData.Email}
                              autoComplete='off'
                              disabled={lock}
                              onChange={(event: any) =>
                                this.handleChange(event, "email")}
                            />
                          </div>
                        </Form.Group>
</div>
<div className="col-md-6" >
                        <Form.Group className="rm-bottom-margin" controlId="phone">
                          <Form.Label> Phone Number  </Form.Label>
                          <div className="single-select">
                            <Form.Control type="text" id="txtphone"
                              value={this.state.formData.Phone}
                              className="form-controlCustom"
                              autoComplete='off'
                              disabled={lock}
                              onChange={(event: any) =>
                                this.handleChange(event, "phone_number")}
                            />
                          </div>

                        </Form.Group>
</div>
<div className="col-md-6" >
                        <Form.Group className="rm-bottom-margin" controlId="customercode">
                          <Form.Label> City  </Form.Label>
                          <div className="single-select">
                            <Form.Control type="text" id="txtCity"
                              value={this.state.formData.city}
                              autoComplete='off'
                              disabled={lock}
                              onChange={(event: any) =>
                                this.handleChange(event, "city")}
                            />
                          </div>
                        </Form.Group>
                        </div>
                        <div className="col-md-6" >
                        <Form.Group className="rm-bottom-margin" controlId="states">
                          <Form.Label> State </Form.Label>
                          <div className="single-select">
                            <Form.Control type="text" id="txtstates"
                              value={this.state.formData.state}
                              autoComplete='off'
                              className="form-controlCustom"
                              disabled={lock}
                              onChange={(event: any) =>
                                this.handleChange(event, "state")}
                            />
                          </div>

                        </Form.Group>
</div>
<div className="col-md-6" >
                        <Form.Group className="rm-bottom-margin" controlId="OtherCharge">
                          <Form.Label> Zip</Form.Label>
                          <div className="single-select">
                            <Form.Control type="text" id="txtOtherCharge"
                              value={this.state.formData.zip}
                              autoComplete='off'
                              className="form-controlCustom"
                              disabled={lock}
                              onChange={(event: any) =>
                                this.handleChange(event, "zip")}
                            />

                          </div>

                        </Form.Group>
</div>

<div className="col-md-6" >
                        <Form.Group className="rm-bottom-margin" controlId="OtherCharge">
                          <Form.Label> Status</Form.Label>
                        <div className="single-select type">
                                                  <SingleDropdownListWithoutSearch
                                                  itemList={this.state.selectOptions}
                                                  handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                                                  defaultItem={this.state.formData.status}
                                                  defaultText={"Select status"}
                                                  defaultName={this.state.formData.status}
                                                  controlID="1"
                                                  id={"ddlselected"}
                                                  key="id"       
                                                />
                                                
                                            </div>

                        </Form.Group>
</div>
</div>



                      </div>
                    </div>
                  </div>
</div>
<div className="row mt-5">
 <div className="col-12 col-md-3 px-3 d-flex align-items-center justify-content-between">
                    <Form.Label className="font-semibold">
                      Default Payroll Bank
                    </Form.Label>

                 <div className="form-check form-switch">
                          <Form.Check
                             className="knob"
                             id="payrollbank"
                             type="switch"
                             checked={this.state.formData.ispayrollDefault}
                             onChange={(event) =>this.handleChange(event, "isDefault")}                                     autoComplete="off"
                            />
                         </div>
                  </div>

                        
                  </div>

                </section>


    <div className="filter-sec height-100">

                    <br></br>
                    <br></br>

                    </div>






                <div className={"footer-section viewer-panel"}
                  style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
                >
                  <div>
                    <div className="d-flex align-items-center justify-content-end height-72">
                      <div className="d-flex align-items-center">
                        {((hasEditPermission && this.state.formData.id > 0) || (hasAddPermission && this.state.formData.id === 0)) &&
                          (
                            <>
                              <Button
                                variant="primary"
                                type="button"
                                className="space btn btn-primary btn-discard"
                                onClick={this.closeSlideOut}
                              >
                                Discard
                              </Button>
                              <Button
                                id="btnSave"
                                variant="primary"
                                type="button"
                                onClick={() => this.saveItem()}

                              >
                                {this.state.formData.id == 0 ? "Create" : "Update"}
                              </Button>



                            </>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </Container>
          </div>

        

          {(this.state.isSpinner || this.state.isSaveSpinner) && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}






        </div>

      </section>
    );
  }
}

const mapStateToProps = (state) => ({
    permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId  
});

export default connect(mapStateToProps)(BankMasterSlidout);